import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Steps from "@/components/landing/Steps";
import Prizes from "@/components/landing/Prizes";
import Activity from "@/components/landing/Activity";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";
import StickyCta from "@/components/landing/StickyCta";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-[#FFFFFF] font-body text-slate-900 antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Steps />
        <Prizes />
        <Activity />
        <Faq />
      </main>
      <Footer />
      <StickyCta />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
